/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VoteBody
 */
export interface VoteBody {
    /**
     * 
     * @type {string}
     * @memberof VoteBody
     */
    entryId: string;
    /**
     * Required for BRACKET_VOTE type
     * @type {string}
     * @memberof VoteBody
     */
    matchupId?: string;
}

/**
 * Check if a given object implements the VoteBody interface.
 */
export function instanceOfVoteBody(value: object): value is VoteBody {
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    return true;
}

export function VoteBodyFromJSON(json: any): VoteBody {
    return VoteBodyFromJSONTyped(json, false);
}

export function VoteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'],
        'matchupId': json['matchupId'] == null ? undefined : json['matchupId'],
    };
}

export function VoteBodyToJSON(json: any): VoteBody {
    return VoteBodyToJSONTyped(json, false);
}

export function VoteBodyToJSONTyped(value?: VoteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'matchupId': value['matchupId'],
    };
}

